<template>
	<AuthLayout title="Verify email">
		<div
			class="list-group-item p-4"
			v-if="sharedState.loading"
		>
		</div>
	</AuthLayout>
</template>

<script>
import AuthLayout from '@/layouts/AuthLayout.vue'
import auth from '@/auth'

export default {
	components: { AuthLayout },
	async mounted() {
		auth.resetAuthMessages()
		const token = this.$route.params.token
		this.sharedState.loading = true
		try {
			await auth.submitVerifyEmail(token)
			this.sharedState.authSuccess = 'Email address verification was successful, you can log in now.'
			this.$router.push('/login')
		} catch (error) {
			this.sharedState.authError = error
		} finally {
			this.sharedState.loading = false
		}
	},
}
</script>
